import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDoubleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M13.875 4.219c.063.062.125.156.094.25a.44.44 0 0 1-.094.281l-9.187 9.188c-.063.062-.125.062-.25.062-.094 0-.188 0-.25-.062L.093 9.811C.03 9.783 0 9.689 0 9.595q0-.188.094-.281l.875-.876q.093-.093.281-.093c.094 0 .156.031.219.094l2.968 2.968L12.5 3.344a.28.28 0 0 1 .219-.094q.188 0 .281.094zM4.094 7.937l-3-3.03A.36.36 0 0 1 1 4.656q0-.189.094-.282l.875-.875c.093-.062.187-.125.281-.125s.188.063.25.125l1.875 1.906L9.625.094A.36.36 0 0 1 9.875 0q.188 0 .281.094l.875.906c.063.063.125.156.125.25s-.062.188-.125.281L4.625 7.938C4.563 8 4.5 8 4.375 8c-.094 0-.187 0-.281-.062"
    />
  </svg>
);
export default SvgDoubleCheck;
